import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const GENERATE_EM_BELL_CURVE_REPORT = "GENERATE_EM_BELL_CURVE_REPORT";

export const service = async (data) => {
  const options: object = {
    url: `/Api/Reports/GenerateEAndMBellCurveReport`,
    method: "POST",
    contentType: "application/json",
    body: JSON.stringify(data),
    ...getDefaultOptions(),
  };

  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GENERATE_EM_BELL_CURVE_REPORT, service, mock);
